import { TypedDocumentNode, gql } from '@apollo/client';
import { styled } from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { CardItem } from '@sorare/core/src/components/card/CardItem';
import { Cost } from '@sorare/core/src/components/player/Cost';

import { AnyPlayerStatsIcon } from 'components/player/AnyPlayerStatsIcon';
import { InjuryTag } from 'components/player/InjuryTag';

import { AnyPlayerProperties_anyPlayer } from './__generated__/index.graphql';

const Wrapper = styled(Horizontal)`
  flex-wrap: wrap;
  max-height: var(--quadruple-unit);
  overflow: hidden;
  & > * {
    flex: 0 0 auto;
  }
`;

type Props = {
  player: AnyPlayerProperties_anyPlayer;
  onStatsClick: () => void;
};

export const AnyPlayerProperties = ({ player, onStatsClick }: Props) => {
  return (
    <Wrapper>
      <AnyPlayerStatsIcon player={player} onClick={onStatsClick} />
      <Cost score={player.lastTenPlayedSo5AverageScore} />
      <CardItem value="+ 5%" />
      <InjuryTag player={player} size="small" />
    </Wrapper>
  );
};

AnyPlayerProperties.fragments = {
  anyPlayer: gql`
    fragment AnyPlayerProperties_anyPlayer on AnyPlayerInterface {
      slug
      ...InjuryTag_anyPlayer
      lastTenPlayedSo5AverageScore: averageScore(
        type: LAST_TEN_PLAYED_SO5_AVERAGE_SCORE
      )
      ...AnyPlayerStatsIcon_anyPlayer
    }
    ${AnyPlayerStatsIcon.fragments.anyPlayer}
    ${InjuryTag.fragments.anyPlayer}
  ` as TypedDocumentNode<AnyPlayerProperties_anyPlayer>,
};
